'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useDecisions } from '../../../hooks';
const DEFAULT_BUTTON_DISPLAY_VAR = '--medallia-side-button-display';
export function useMedalliaDefaultButton() {
  const $ = _c(3);
  const isMedalliaDefaultEnabled = useDecisions("medallia");
  let t0;
  let t1;
  if ($[0] !== isMedalliaDefaultEnabled) {
    t0 = () => {
      const documentStyles = document.documentElement.style;
      if (isMedalliaDefaultEnabled) {
        documentStyles.setProperty(DEFAULT_BUTTON_DISPLAY_VAR, "flex", "important");
      }
      return () => {
        documentStyles.removeProperty(DEFAULT_BUTTON_DISPLAY_VAR);
      };
    };
    t1 = [isMedalliaDefaultEnabled];
    $[0] = isMedalliaDefaultEnabled;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}